import React from "react";

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from "../helpers/utils";

import {
  Chart,
  Series,
  Export,
  ArgumentAxis,
  Label,
  Legend,
  Tooltip,
  ValueAxis,
} from "devextreme-react/chart";
import { Card } from "react-bootstrap";

class barChartCoverage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      getData: [],
      errorMessage: "",
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    let resp = await getStatisticsFromOrigin(
      global.config.backend.baseURI + "/api/Coverage/GetUserProductCoverage"
    );

    if (resp) {
      this.setState({ getData: resp });
    }
  };

  render() {
    if (this.state.getData !== null) {
      return (
        <Card className="rounded-4">
          <Card.Body>
            <Card.Title>
              User Product Coverage
              <div className="float-end">
                <span
                  className="fullscreen-link"
                  onClick={() => {
                    renderFullScreen("#chartCoverage");
                  }}
                >
                  Full Screen
                </span>
                <span> | </span>
                <span
                  className="fullscreen-link"
                  onClick={() => {
                    exportData("ProductUserCoverage", this.state.getData);
                  }}
                >
                  Export
                </span>
              </div>
            </Card.Title>
            <Card.Subtitle>
              Product Coverage by number of unique active Users
            </Card.Subtitle>
            <Chart
              id="chartCoverage"
              dataSource={this.state.getData}
              rotated={true}
            >
              <Legend visible={false} />
              <Tooltip
                enabled={true}
                location="edge"
                customizeTooltip={this.customizeTooltip}
                zIndex={10000}
              />
              <ValueAxis type="logarithmic" />
              <Series
                valueField="userCount"
                argumentField="description"
                name="Product User Coverage"
                type="bar"
                color="#d505f5"
              />
              <Export enabled={true} />
              <ArgumentAxis>
                <Label wordWrap="break" overlappingBehavior={"rotate"} />
              </ArgumentAxis>
            </Chart>
          </Card.Body>
        </Card>
      );
    }
  }

  customizeTooltip(arg) {
    return {
      text: `${arg.argumentText} User Count: ${arg.valueText}`,
    };
  }
}

export default barChartCoverage;
